import { graphql } from '@/graphql-setup'

export const PATCH_INFRINGEMENT_MUTATION = graphql(`
  mutation PatchInfringement($id: ID!, $input: PatchInfringementInput!) {
    patchInfringement(id: $id, input: $input) {
      infringement {
        id
        archivedAt
        leadersComment
      }
    }
  }
`)
